
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: 'Trao đổi',
    bba: 'Tài khoản tiền tệ',
    hy: 'Hợp đồng',
    jg: 'Hoán đổi',
    hya: 'Tài khoản hợp đồng'
  },
  index: {
    h24: 'Khối lượng 24 giờ',
    header_title: ['Chọn giao dịch tài sản kỹ thuật số ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa',
    header_msg: 'An toàn-ổn định-đáng tin cậy',
    register_title: 'Đăng ký một ' + window.GLOBAL.LANG_TITLE.zh + ' tài khoản toàn cầu bắt đầu hành trình giao dịch',
    register_pl: 'Vui lòng nhập email hoặc điện thoại di động của bạn',
    register: 'Đăng ký',
    featureTitleWhy: 'Tại sao chọn chúng tôi',
    featureTitle: 'An toàn · ổn định · đáng tin cậy',
    featureMsg: '',
    featureList: [
      {icon: icon1, title: 'Công nghệ Ví an toàn', msg: ['Công nghệ ví nóng và lạnh được phát triển bởi nhóm bảo mật hàng đầu thế giới và chưa bao giờ xảy ra sự cố mất tiền. ',' ']},
       {icon: icon2, title: 'kinh doanh tài sản tiền điện tử phong phú', msg: ['hỗ trợ giao ngay và nhiều giao dịch phái sinh, v.v., là người quản lý cá nhân của bạn trong thế giới tài sản tiền điện tử. ',' ']},
       {icon: icon3, title: 'Khách hàng được phân phối trên toàn thế giới', msg: ['Đối với người dùng ở hơn 130 quốc gia hoặc khu vực trên thế giới, chúng tôi cung cấp đầy đủ các dịch vụ tài sản mã hóa. ',' ']}
    ],
    bannerList: [
      {icon: banner01, title: "Cam kết cung cấp sự ổn định và bảo mật hàng đầu trong ngành", msg: ["hợp đồng thông minh để bảo vệ an toàn tài sản của nhà đầu tư", "hiệu suất giao dịch thực", "đảm bảo dịch vụ 24 giờ"]},
      {icon: banner02, title: "Tôi muốn mua và bán ngay lập tức thông qua các thao tác đơn giản", msg: ["màn hình giao dịch đơn giản", "phản ánh ngay lập tức trong số dư tài khoản của bạn", "hầu hết các loại tiền điện tử có thể được giao dịch"]},
      {icon: banner03, title: "Tôi muốn tích cực kiếm lợi nhuận thông qua giao dịch hợp đồng thanh toán", msg: ["Mở tài khoản cùng lúc", "Đầu tư chiến lược cho một số lượng lớn hợp đồng tương lai", "Bạn có thể giao dịch 24 giờ một ngày, 365 ngày một năm, ngay cả vào cuối tuần "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Minh bạch và cởi mở", msg: ["Sử dụng các đặc điểm của blockchain và hợp đồng thông minh, nhận ra hiệu suất giao dịch trên chuỗi và sử dụng hợp đồng thông minh để đảm bảo an toàn cho tài sản của nhà đầu tư", ""] },
      {icon: icon1_02, title: "Đầu tư Thông minh", msg: ["Với các chiến lược đa dạng được cung cấp bởi các chuyên gia giao dịch định lượng hàng đầu, bạn có thể tự do lựa chọn", ""]},
      {icon: icon1_03, title: "Phân loại rủi ro", msg: ["Thiết kế các sản phẩm đầu tư đa dạng dựa trên các rủi ro khác nhau và sở thích quản lý tài sản của từng nhà đầu tư, loại bỏ hiệu quả các ngưỡng đầu tư", ""]},
      {icon: icon1_04, title: "Sản phẩm đa dạng", msg: ["Cung cấp nhiều loại nhu cầu đầu tư của người dùng và cơ chế nền tảng linh hoạt, đồng thời tiếp tục sản xuất các dịch vụ tài chính sáng tạo tốt hơn thị trường", ""]}
    ],
    featureTitle2: 'Giao dịch đầu cuối đa nền tảng mọi lúc, mọi nơi',
    featureMsg2: 'Bao gồm nhiều nền tảng iOS và Android, hỗ trợ các chức năng đầy đủ dịch vụ',
    tab: ['Tiền tệ chính', 'Danh sách tăng 24H'],
    thead: ['Tên', 'Giá mới nhất', 'Giá cao nhất trong ngày', 'Giá thấp nhất trong ngày', 'Danh sách tăng', 'Khối lượng 24H', 'Hoạt động'],
    more: 'xem thêm >',
    btn: 'Giao dịch',
    dealsTitle: 'Dịch vụ giao dịch một cửa',
    dealsTab:[
      { title: 'Trao đổi', content: 'Giao dịch tiền tệ là để trao đổi giữa các tài sản kỹ thuật số, sử dụng USDT làm đơn vị định giá để mua các loại tiền tệ khác.'+window.GLOBAL.LANG_TITLE.zh+'Giao dịch tiền tệ hỗ trợ giao dịch thời gian thực của các tài sản kỹ thuật số như Bitcoin, Ethereum và Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Hợp đồng', content: 'Một phái sinh tài chính của tiền kỹ thuật số không chỉ hỗ trợ lựa chọn mua hợp đồng bán dài hoặc bán ngắn để kiếm thu nhập, mà còn vận hành đơn giản và không bao giờ hết hạn.'+window.GLOBAL.LANG_TITLE.zh+'Hợp đồng có hệ thống quản lý rủi ro tiên tiến với đòn bẩy lên đến 100 lần.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Tùy chọn', 'Hợp đồng', 'Đồng xu'],
    thead: ['Tiền tệ', 'Giá mới nhất', 'Thay đổi trong 24 giờ', 'Thấp nhất trong 24 giờ', 'Cao nhất 24 giờ', 'Khối lượng 24 giờ', 'Hoạt động'],
    nodata: 'Không có dữ liệu'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Về chúng tôi",
        dd: [{title: "Hồ sơ công ty", id: 1}, {title: "Trung tâm trợ giúp", type: 'help'}]
      },
      {
        dt: "Hỗ trợ người dùng",
        dd: [
          {title: "Thỏa thuận người dùng", id: 3},
          {title: "Chính sách quyền riêng tư", id: 5}
        ]
      },
      {
        dt: "liên hệ chúng tôi",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["Đăng nhập", "Đăng ký", "Quản lý tài sản", "Tải xuống APP"],
    nav: [
      { title: "Trang chủ", path: "/index",name: 'index' },
      { title: "Thị trường", path: "/market",name: 'market' },
      // { title: "Trao đổi", path: "/deal", name: 'deal'},
      // { title: "Hợp đồng", path: "/deal_c", name: 'deal_c' },
      { title: "Hoán đổi", path: "/deal_jg", name: 'deal_jg' },
      { title: "Giữ lại tiền hoàn lại", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "Tài sản của tôi", path: "/asset" }],
    menus: [
      {icon: langzh, title: "Trung tâm Người dùng", path: "/setting"},
      {icon: langen, title: "Đăng xuất"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Tải xuống"
  },
  // 登录
  login: {
    login: 'Vui lòng đăng nhập',
    msg: 'Vui lòng nhập tài khoản đã đăng ký của bạn',
    list: ['Di động / Email', 'Mật khẩu', 'Quên mật khẩu?', 'Đăng nhập', 'Không có tài khoản, đăng ký ngay'],
    message: 'Tài khoản hoặc mật khẩu không được để trống'
  },
  register: {
    dl: ['Đăng ký di động', 'Đăng ký email'],
    title: 'Đăng ký tài khoản',
    country: 'Quốc tịch',
    country_info: 'Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực',
    account: 'số tài khoản',
    code_text: 'mã xác nhận',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    code_no_data: 'mã xác minh phải được điền',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    pid_text: 'Mã mời',
    pid_pl: 'Không bắt buộc',
    invitation_code_no_data: 'Mã lời mời là bắt buộc',
    xy: 'sự thỏa thuận của người dùng',
    xy_no_checked: 'Vui lòng chọn giao thức',
    agree: 'Tôi đã đọc và đồng ý',
    register_btn: 'Đăng ký',
    bz: ['Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực. ',' Email xác minh có thể bị đánh giá sai là thư rác, vui lòng kiểm tra kỹ. ', 'Hãy giữ của bạn' + window.GLOBAL.LANG_TITLE.zh + 'Số tài khoản và mật khẩu đăng nhập.', 'Không sử dụng cùng mật khẩu đăng nhập với các trang web khác.'],
    account_no_data: 'Tài khoản không được để trống',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau'
  },
  // 设置密码
  bindmpwd: {
    title: 'đặt mật khẩu',
    account: 'Số tài khoản',
    code_text: 'mã xác nhận',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    bindmpwd_btn: 'Xác nhận',
    phone_no_data: 'Số điện thoại không được để trống',
    password_login_text: 'Vui lòng nhập mật khẩu đăng nhập',
    password_trade_text: 'Mật khẩu gồm 6 chữ số',
    password_again_tarde_text: 'Mật khẩu gồm 6 chữ số',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Sửa đổi mật khẩu', 'Quên mật khẩu'],
    account: '账号',
    code_text: 'mã xác nhận',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',

    phone_no_data: 'Số điện thoại không được để trống',

    account_no_data: 'Tài khoản không được để trống',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    forgetpwd_btn: 'Xác nhận'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Ràng buộc số điện thoại di động',
    phone_text: 'số điện thoại',
  },
  person: {
    more: 'Tải thêm',
    no_more: 'Không có thêm dữ liệu',
    index_center:"Trung tâm người dùng",
    index_menus: [
      { icon: zhsz, title: "Quản lý tài khoản", path: '/setting' },
      { icon: sfrz, title: "Xác thực KYC", path: '/sfyz' },
      { icon: sfrz, title: "Chứng chỉ sơ cấp", path: '/smauth' },
      { icon: sfrz, title: "Đã xác minh", path: '/seniorauth' },
      { icon: jtrz, title: "Xác thực địa chỉ", path: '/dzrz' },
      { icon: jtrz, title: "Mua Tiền mật mã", path: '/kjmbSelect' },
      { icon: jtrz, title: "Điểm tín dụng", path: '/credit' },
      { icon: jtrz, title: "Hồ sơ", path: '/deallog' },
      { icon: jtrz, title: "Hồ sơ tiền ký quỹ", path: '/cbjl' },
      { icon: jtrz, title: "Hồ sơ rút tiền", path: '/tbjl' },
    ],
    cbtb: 'Ký quỹ & Rút tiền',
    jymx: 'Chi tiết giao dịch',
    xyf: {
      'title': 'Điểm tín dụng',
      'pgsj': 'Thời gian đánh giá'
    },
    smrz:{
       title:'Đã xác minh' ,
       sure_title: 'Bạn đã vượt qua xác thực tên thật',
       zj_type: 'Loại chứng chỉ',
       zj_info: ['1, không thể sửa đổi thông tin chứng nhận sau khi đã xác minh, vui lòng điền trung thực', '2, thông tin tên thật đã xác minh không thể được chứng nhận lại'],
       zj_name: 'Tên',
       zj_num: 'số tài liệu',
       zj_btn: 'Được',
       zj_rebtn: 'Xác minh lại',
       zj_sebtn: 'Xác minh nâng cao',
       zj_type_array:[{name:'Thẻ ID',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Thẻ ID"
        },
        {
            id: 2,
            name: "Hộ chiếu"
        },
        {
            id: 3,
            name: "Bằng lái xe"
        },
        {
            id: 4,
            name: "giấy phép thường trú"
        },
        {
            id: 5,
            name: "khác"
        }
       ],
       zj_data:{city:'Quốc tịch không được để trống',type:'Loại thông tin xác thực không được để trống',name:'Không được để trống tên',zj_num:'Không được để trống số ID'},
       zsxm: 'Tên thật',
       qsrzsxm: 'Vui lòng nhập tên thật của bạn',
       zjlx: 'Loại ID hợp lệ',
       qxzzjlx: 'Vui lòng chọn loại ID',
       sfz: 'Thẻ ID',
       zjhm: 'Số ID',
       qsrzjhm: 'Vui lòng nhập số ID',
       sczjz: 'Tải lên ảnh ID',
       zjzm: 'Tải lên ảnh mặt trước của tài liệu ID',
       zjfm: 'Tải lên ảnh mặt sau của tài liệu ID',
       qsczjzm: 'Vui lòng tải lên ảnh mặt trước của giấy tờ tùy thân của bạn',
       qsczjfm: 'Vui lòng tải lên ảnh mặt sau giấy tờ tùy thân của bạn',
       scqmz: 'Tải lên các tài liệu ID và chữ ký cá nhân',
       qscscqmz: 'Vui lòng tải lên ID và ảnh chữ ký cá nhân của bạn',
       zj: [
         {
           id: 1,
           title: 'Thẻ ID'
         },
         {
           id: 2,
           title: 'Hộ chiếu'
         },
         {
           id: 3,
           title: 'khác'
         },
       ],
       tj: 'Gửi',
       shz: 'Đang xem xét',
       shtg: 'Đã phê duyệt'
    },
    gjrz:{
      title:'Chứng chỉ cao cấp',
      zj_info:['1. Hỗ trợ các ảnh dưới 8MB và định dạng JPG, JPEG hoặc PNG.','2. Các ảnh tài liệu ID phải rõ ràng và sẽ không bị chỉnh sửa hoặc che khuất. Mã số tài liệu ảnh cá nhân và tên của chủ sở hữu tài liệu phải dễ nhìn.','3. Các ảnh phải được chụp mà không có bất kỳ vật che đầu nào và không khuyến khích trang điểm khi chup. Các đường nét khuôn mặt trong ảnh phải rõ ràng và dễ nhận biết và không để lộ toàn bộ tay.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Cài đặt hệ thống bảo vệ',
      bind:[{bind_title: 'Đặt lại mật khẩu', bind_name: 'Email'}, {bind_title: 'Đặt mật khẩu giao dịch', bind_name: 'Email'}]
    },
    wdtg:{
      own_code: 'Mã lời mời độc quyền',
      own_code_url: 'Kết nối lời mời độc quyền',
      own_push_title: 'Quảng cáo của tôi',
      own_push_content: ['Tổng doanh thu từ lời mời (định giá)', 'số lượng lời mời', 'số người'],
      own_push_content_profit: ['Quyền lợi lời mời cấp độ 1', 'Quyền lợi lời mời cấp độ 2', 'Quyền lợi lời mời cấp độ 3', 'Quyền lợi lời mời cấp độ 4'],
      own_push_content_num: ['Số lượng lời mời ở cấp độ đầu tiên', "Số lượng lời mời ở cấp độ thứ hai", "Số lượng lời mời ở cấp độ thứ ba", "Số lượng lời mời ở cấp độ thứ tư"],
      own_push_profit_title: ['ID', 'lợi nhuận', 'thông tin nhận xét', 'thêm thời gian'],
      own_push_num_title: ['ID', 'name', 'phone', 'add time'],
    },
    jyzt_td: ['Thời gian', 'chi tiết', 'lượng'],
    cbjl_td: ['Thời gian', 'tiền tệ', 'số lượng', 'trạng thái'],
    sfrz_txt: ['Xác thực danh tính', 'Bạn đã gửi kiểm tra, vui lòng đợi kết quả', 'Bạn đã vượt qua xác thực nâng cao', 'Mặt trước của thẻ ID', 'Mặt sau của thẻ ID', 'Xác thực', ' Xác thực không thành công, vui lòng xác thực lại '],

    zhsz_txt: ['Cấp độ bảo mật tài khoản của bạn: #', 'Cấp độ bảo mật tài khoản của bạn: #, cải thiện thêm thông tin và đảm bảo bảo mật tài khoản'],
    zhsz_m: 'mạnh',
    zhsz_n: 'yếu',
    zhsz_p: 'không an toàn',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu đăng nhập', value: 'Tài khoản Internet có nguy cơ bị đánh cắp. Bạn nên thay đổi mật khẩu thường xuyên để bảo vệ an toàn cho tài khoản của mình. ', value2:'', btn:'biến đổi', bind_email:' trước tiên hãy liên kết email hoặc điện thoại di động', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu giao dịch', value: 'Đặt mật khẩu', btn: 'Chuyển đến thiết lập', path: '/bindmpwd' }
    ],
    sksz_txt: ['Cài đặt Biên nhận', 'Lưu'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Trang chủ',
    prev: 'Trang trước',
    next: 'Trang tiếp theo',
    last: 'Trang Cuối cùng',
    no_data: 'Không có dữ liệu',
  },
  asset: {
    title: 'Tài sản của tôi',
    zjhz: 'Chuyển quĩ',
    cb: 'Tiền ký quỹ',
    gz: 'Định giá USDT',
    atnv: [],
    zh_title: 'Tổng tài sản quy đổi：',
    index_title: 'tài sản',
    address_title: 'Tiền tệ',
    address_txt: ['xin vui lòng chọn', 'Địa chỉ rút tiền', 'Vui lòng nhập nội dung', 'nhận xét', 'danh sách địa chỉ'],
    address_btn: ['Thêm', 'Lưu', 'Xóa', 'Chỉnh sửa'],
    address_td: ['Tiền tệ', 'Địa chỉ rút tiền', 'Chú thích', 'Vận hành'],
    currency_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi'],

    table_title: 'Tổng tài sản：',
    table_address_title: 'Quản lý địa chỉ rút tiền',
    table_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi', 'Vận hành'],
    table_btn: ['Tiền ký quỹ', 'Rút tiền', 'ghi âm', 'chuyển khoản'],

    money_text: ['Địa chỉ rút tiền', 'xin vui lòng chọn', 'Số lượng', 'Khả dụng：', 'Phí',
      'Số tiền đến', 'Mật khẩu giao dịch','Thẻ (Ghi nhớ)','Tối thiểu '],
    money_btn: 'Rút tiền',
    xzbz: 'Lựa chọn tiền tệ',
    money_msg: ['Lời nhắc', '1. Thời gian rút tiền là 12: 00-24: 00 giờ Hồng Kông, với 2 đơn rút tiền mỗi ngày (rút tối thiểu 100u, rút ​​tối đa 200.000u);', '2. Hiện tại, rút ​​tiền chỉ được hỗ trợ bằng tiền USDT, Loại liên kết ví chọn ERC20; ',' 3. Sau khi gửi đơn xin rút tiền, tiền sẽ bị đóng băng do quá trình rút tiền đang diễn ra và tiền tạm thời được quản lý bởi hệ thống và bạn không thể tự do kiểm soát. Nó không có nghĩa là bạn đã mất tài sản hoặc tài sản bất thường. Vui lòng kiên nhẫn chờ phê duyệt; ',' 4. Thời gian đến sau khi gửi đơn rút tiền tùy thuộc vào thời gian xác nhận của khối. Nếu không dự kiến ​​rút tiền sau thời gian rút tiền, vui lòng liên hệ với bộ phận chăm sóc khách hàng để được giải đáp; ',' 5. Để ngăn chặn Thiết lập hành vi hiện tại, 90% tổng số tiền tiêu dùng được yêu cầu để bắt đầu rút tiền '],

    recharge_title: 'Địa chỉ nạp tiền',
    recharge_btn: ['Sao chép', 'Mã QR', 'Tiền ký quỹ'],
    recharge_text: ['Số lượng', 'Lời nhắc', 'Không nạp tiền cho bất kỳ tài sản không phải USDT nào vào địa chỉ trên, nếu không tài sản sẽ không được truy xuất. ',' Tiền gửi USDT chỉ hỗ trợ phương thức gửi đơn giản, tiền gửi sử dụng các phương thức khác (gửi tất cả) tạm thời không thể được đăng, xin vui lòng hiểu. ','Thông tin đăng nhập', 'diễn tả(Không bắt buộc)','Tên chuỗi'],

    record_title: 'Các báo cáo tài chính',
    record_td: ['Số lượng', 'ghi âm', 'Thời gian'],

    transfer_title: 'chuyển khoản',
    transfer_btn: ['Tất cả', 'chuyển giao'],
    transfer_text: ['Từ', 'đến', 'Vui lòng nhập số tiền chuyển', 'Khả dụng：'],
    "bq": "Thẻ (Ghi nhớ)",
    "qsrbq": "Vui lòng nhập thẻ",
    "yhktx": "Rút qua thẻ ngân hàng",
    "yhmc": "Tên ngân hàng",
    "qsryhmc": "Vui lòng nhập tên ngân hàng",
    "yhzh": "Tài khoản ngân hàng",
    "qsryhzh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjhkdm": "Mã SWIFT",
    "qsrgjhkdm": "Vui lòng nhập mã SWIFT",
    "yhdz": "Địa chỉ ngân hàng",
    "qsryhdz": "Vui lòng nhập địa chỉ ngân hàng",
    "skrxm": "Tên người hưởng",
    "qsrskrxm": "Vui lòng nhập tên người hưởng",
    "skrdh": "Số điện thoại của người hưởng",
    "qsrskrdh": "Vui lòng nhập số điện thoại của người hưởng",
    "skrdz": "Địa chỉ của người hưởng",
    "qsrskrdz": "Vui lòng nhập địa chỉ của người hưởng"
  },
  text: {
    btn: 'return',
    login: 'Vui lòng đăng nhập trước'
  },
  deal: {
    chooseType: 'Loại hoa hồng',
    choose: 'xin vui lòng chọn',
    balance: 'Số dư：',
    account: ['Tài khoản', 'Có sẵn', '/ Đóng băng', 'Chuyển khoản'],
    dir: ['Mua', 'Bán'],
    dir2: ['Khả dụng', 'Có thể mua bán'],
    cs: 'Tùy chọn',
    sxf: 'Phí',
    jye: 'Giao dịch',
    sc_list: ['Thị trường', 'Tên', 'giá tăng'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['tiền tệ', 'giá mới nhất', 'giá đã tăng'],
    k_line_txt: ['≈', '', 'Tăng', 'Giá cao nhất', 'Giá thấp nhất', 'Khối lượng 24 giờ'],
    tabListLTitle: ["Lệnh mở", "Hoa hồng lịch sử"],
    tabListLEntrust: ["Mua", "Bán"],
    tabListRTitle: ["Hạn chế giao dịch", "Giao dịch thị trường"],
    table_btn: ['Hủy lệnh'],
    index_td_l: ['Thời gian', 'Đối tượng giao dịch', 'Số lượng', 'Giá', 'Hoạt động'],
    index_td_r: ['Giá mới nhất', 'hướng đi', 'Giá', 'số lượng'],
    index_td_r2: ['Giao dịch mới nhất', 'Thời gian', 'Giá', 'Khối lượng giao dịch'],
    table_txt: ['Đã hoàn tất', 'Đã hủy lệnh'],

    db_1_txt: ["Có sẵn", "Giá mua", "Giá bán", "Khối lượng mua", "Khối lượng bán", "Khối lượng giao dịch", "Mua với giá tốt nhất thị trường", "Giá tốt nhất thị trường để bán ",' mua tay ',' bán tay '],
    db_2_txt: ['Giá', 'đòn bẩy', 'vui lòng chọn', 'lô', 'một lô bằng', 'lô', 'giá trị thị trường hợp đồng', 'ký quỹ', 'mua với giá thị trường tốt nhất', ' tại thị trường Bán giá tốt nhất '],
    pathList: ['Bản ghi hợp đồng', 'Bản ghi giao dịch'],
    db_btn: ['Mua (mua lâu dài)', 'Bán (bán khống)'],
    tabListLTitle2: ['Lệnh mở'],

    lt_btn: ['Thanh khoản một lần nhấp chuột', 'Đặt mức dừng lãi và giá cắt lỗ', 'Đóng', 'Xác nhận ngay bây giờ', 'trở về'],
    lt_txt: ['Tỷ lệ rủi ro:', 'Tổng lãi và lỗ của vị thế:'],
    lt_td: ['Loại', 'Đòn bẩy nhiều', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở', 'Số lô', ' Lãi và lỗ ',' Hoạt động '],
    lt_dl: ['Set the Stop Loss and price cắt lỗ', 'Chốt lời', 'Giá cắt lỗ'],

    lt_0_btn: ['Hủy lệnh'],
    lt_0_td: ['Thông tin liên hệ', 'Đơn vị tiền tệ', 'Số lượng', 'Giá hiện tại', 'Phí xử lý', 'Vận hành'],

    lt_1_btn: ['Đóng'],
    lt_1_txt: ['Đang đóng'],
    lt_1_td: ['Loại', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở cửa', 'Phí xử lý', 'Lãi lỗ', 'Hoạt động'],
    node_data: 'Không có dữ liệu',

    lt_3_txt: ['Đã đóng', 'Thanh toán'],
    lt_3_td: ['Loại', 'Lô', 'Giá vị thế', 'Giá đóng cửa', 'Giá chốt lời', 'Giá cắt lỗ', 'Ký quỹ', 'Ký quỹ khả dụng', 'Thời gian mở cửa', 'Thời gian đóng cửa', ' Phí xử lý ','Lãi và lỗ', 'hoạt động'],

    lt_4_txt: ['Đã hủy lệnh'],
    cm: ['Thời gian công bố', 'Mã số phát hành', '流通总量', '总凑价格', 'Trang web chính thức','Sách trắng','介绍'],
    qsrsl: 'Vui lòng nhập số tiền',
    qsrss: 'Vui lòng nhập lô',
  },
  notice:{
      notice_title:'Trung tâm thông báo',
  },
  bzhl:{
    title: 'Giữ lại tiền hoàn lại',
    ttzbt: '天天赚不停',
    wdtg: 'Lưu trữ của tôi',
    zztgdzj: 'Quỹ giám hộ',
    yjjrsy: 'Ước tính hàng ngày',
    ljsy: 'Tổng doanh thu',
    tgzdd: 'Lệnh giám hộ',
    tgdd: 'Lệnh ký quỹ',
    t1: 'Rủi ro thấp và quản lý tài chính ổn định, có thể đổi trả bất kỳ lúc nào nếu cần',
    t2: 'Trợ lý quản lý tiền miễn phí của bạn',
    cljxcp: 'Chu kỳ sản phẩm',
    dbxe: 'Hạn mức đơn',
    rsyl: 'Năng suất(%)',
    rsyl2: 'Lợi suất hàng ngày：',
    zq: 'Chu kỳ',
    qmr: 'Đi mua',
    ckgd: '더보기',
    cpgk: 'Tổng quan về sản phẩm',
    pxsj: 'Thời gian thanh toán cổ tức',
    tgzj: 'Vốn chủ sở hữu giám hộ',
    tqsh: 'Sự chuộc lỗi sớm',
    cpld: 'Những điểm nổi bật của sản phẩm',
    cpgz: 'Quy tắc sản phẩm',
    cont: 'Di chuyển gạch là bằng cách lưu trữ USDT trên nền tảng và đội ngũ chuyên nghiệp của nền tảng có quyền di chuyển gạch. Người tham gia có thể nhận được phần thu nhập từ chuyển gạch của nền tảng trong thời gian lưu ký quỹ. Có thể truy cập vào bất kỳ lúc nào. là an toàn và thuận tiện.',
    zj: 'Tài trợ 100%',
    aqbz: 'Bảo mật',
    jjrsy: 'Thu nhập vào ngày nghỉ lễ',
    bjd: 'Không gián đoạn',
    cgcrh: 'Sau khi ký quỹ thành công',
    dtqx: 'Giá trị lãi suất theo ngày',
    ljzr: 'Chuyển ngay',
    xqglgj: 'Các công cụ quản lý tiền miễn phí',
    ddh: 'Mã số lệnh',
    tgje: 'Số tiền giám hộ',
    tgsj: 'Chu kỳ ngày',
    yhl: 'Đã có lãi',
    xdsj: 'Thời gian đặt lệnh',
    zt: 'trạng thái',
    fh: 'trở về',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: 'rủi ro đầu tư',
    shsc: 'Thời gian đổi thưởng',
    di: 'Thấp',
    yggzr: 'Một ngày làm việc',
    msgsxf: 'Phí đăng ký miễn phí',
    mr: 'Hàng ngày',
    dqfh: 'Hoàn trả khi đến hạn',
    ljgm: 'Mua ngay',
    tgz: 'Giám hộ',
    sh: 'Đổi',
    ywc: 'Đã hoàn tất',
    ysh: 'Đã đổi',
    all: 'Tất cả các',
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các loại tiền khác"
  },
  pay:{
    qsrjymm: 'Vui lòng nhập mật khẩu giao dịch gồm 6 chữ số',
    tbmmts: 'Vui lòng đến trung tâm người dùng để đặt mật khẩu giao dịch',
  },
  tips:{
    qxztbdz: 'Vui lòng nhập địa chỉ rút tiền',
    qsrtbsl: 'Vui lòng nhập số lượng của tiền tệ sẽ rút'
  },
  statusText: ['Không thành công', 'Đang chờ xử lý', 'Thành công'],
  dzrz: {
    title: 'Xác thực địa chỉ',
    sdddz: 'Địa chỉ hóa đơn tiện ích',
    zdtpsc: 'Tải lên ảnh hóa đơn',
    qsrsdddz: 'Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng',
    qsczdtp: 'Vui lòng tải lên hình ảnh của hóa đơn',
    status: ['đang xem xét', 'đánh giá đã thông qua'],
    qd: 'Được',
  },
  jgcc: {
    wtgd: 'Lệnh đang chờ',
    cj: 'Thỏa thuận',
    jj: 'Thông tin',
    zc: 'Hiện thời',
    lszc: 'Lịch sử',
    qblx: 'Tất cả các loại',
    xj: 'Giá hiện thời',
    sj: 'Thời gian',
    fx: 'Xu hướng',
    jg: 'Giá',
    sl: 'Số lượng',
    jgsj: 'Thời gian giao',
    gmj: 'Giá mua',
    jsj: 'Giá thanh toán',
    yk: 'Lãi và lỗ',
    xq: 'Chi tiết',
    mz: 'Mua dài hạn',
    md: 'Bán ngắn hạn',
    dqye: 'Số dư hiện thời',
    gb: 'Đóng',
    jxxd: 'Tiếp tục đặt lệnh',
    qrxd: 'Xác nhận',
    ddqr: 'Xác nhận lệnh',
    sxf: 'Phí',
    kyye: 'Thăng bằng',
    jypz: 'Tên',
    jyfx: 'Xu hướng',
    tzje: 'Mức giá đầu tư',
    tzjeTips: 'Số tiền đầu tư không được bằng 0',
    dqsj: 'Thời gian hết hạn',
    jssj: 'Thời gian giao',
    gmsj: 'Thời gian mua hàng',
    sy: 'Lãi',
    zxje: 'Số tiền tối thiểu ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Số tiền tối đa ',
    qsrje: 'Vui lòng nhập số tiền',
    zxtzje: 'Tối thiểu ',
    yebz: 'Thiếu cân bằng',
    xq: 'Chi tiết',
    ddz: 'Đang chờ đợi',
    jgjl: 'Biên bản giao hàng',
    bz: 'Tiền tệ',
    cz: 'Vận hành'
  },
  kjmb: {
    title: 'Mua Tiền mật mã',
    fzcg: 'Sao chép thành công',
    ljmb: 'Mua Tiền mật mã',
    lxkf: 'liên hệ với dịch vụ khách hàng'
  },
  news: {
    title: 'Tin nhắn của tôi',
    "gg": "Thông báo",
    ckxq: 'Xem chi tiết'
  },
  statusTabs:['Danh sách hàng chờ', 'Đang giao dịch','Đã đóng', 'Đã rút'],
  "chongzhi":{
    "zy": "Quan trọng",
    "cbxx": "Thông tin tiền gửi mã thông báo",
    "qsrsl": "Vui lòng nhập số tiền gửi",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn",
    "tips2_1": "• Vui lòng không tính phí bất kỳ tài sản không phải nội tệ nào cho địa chỉ trên, nếu không, không thể truy xuất tài sản.",
    "tips2_2": "• Không thể giao tiền kỹ thuật số đúng lúc. Thời gian đến thực tế phụ thuộc vào tốc độ xác nhận của blockchain.",
    "tips2_3": "• Địa chỉ nạp tiền của bạn sẽ không thay đổi thường xuyên, bạn có thể nạp tiền; nếu có bất kỳ thay đổi nào, chúng tôi sẽ cố gắng hết sức để thông báo cho bạn qua email hoặc thông báo trên trang web.",
  },
  "tibi": {
    "tbxx": "Thông tin Rút tiền",
    "qsrbq": "Vui lòng nhập nhãn",
    "tbTips1": "• Để đảm bảo an toàn cho nguồn tiền, khi chính sách bảo mật tài khoản của bạn thay đổi, thay đổi mật khẩu, chúng tôi sẽ xem xét thủ công việc rút tiền, hãy kiên nhẫn chờ nhân viên liên hệ với bạn qua điện thoại hoặc email.",
    "tbTips2": "• Hãy đảm bảo rằng máy tính và trình duyệt của bạn an toàn để ngăn thông tin bị giả mạo hoặc bị rò rỉ.",
    "tbTips3": "• Tài sản kỹ thuật số mà bạn đề cập là tài sản đa chuỗi một xu. Bất kể bạn chọn huy động từ chuỗi nào, điều đó có nghĩa là tổng số tài sản kỹ thuật số hiển thị trên trang rút tiền mà bạn sở hữu sẽ bị giảm bằng số tiền tương ứng đã huy động được. ",
  },
  "gjlb": "Danh sách các quốc gia",
  "qxzgjlb": "Vui lòng chọn Quốc gia / Vùng",
  "mbwt":{
    "title": "Vấn đề An ninh",
    "mbwt": "Vấn đề An ninh",
    "problem":[
      {
        "id": 1,
        "title": "Ai là người bạn thân nhất của bạn?"
      },
      {
        "id": 2,
        "title": "Thần tượng của bạn là ai?"
      },
      {
        "id": 3,
        "title": "Nơi khao khát nhất của bạn là ở đâu?"
      }
    ],
    "qtxda": "Vui lòng trả lời",
    "qsrxmm": "Vui lòng nhập mật khẩu mới",
    "qqrmm": "Vui lòng xác nhận mật khẩu của bạn",
    "sydqmmcz": "Sử dụng Đặt lại Mật khẩu Hiện tại",
    "zhmm": "Vấn đề bảo mật Lấy lại mật khẩu",
    "ysz": "Cài đặt",
    "tg": "Bỏ qua",
    "tj": "Gửi đi",
    "zyts": "Quan trọng:",
    "zytsCont": "Không tiết lộ câu trả lời bí mật và mã xác minh, đồng thời lưu ý vấn đề bảo mật, điều này sẽ giúp bạn lấy lại mật khẩu của mình"
  },
  "zc":{
    "zclb": "Danh sách tài sản",
    "zczh": "Chuyển đổi tài sản",
    "yczc": "Ẩn tài sản bạn không có"
  },
  "indexNew":{
    "t1": "Hàng đầu Toàn cầu",
    "t2": "Nền tảng Dịch vụ Tài sản Kỹ thuật số",
    "t3": "Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa",
    "t4": "Số điện thoại di động / Email",
    "t5": "Đăng ký ngay",
    "t6": "Chào mừng khách hàng từ khắp nơi trên thế giới thông qua GMO Global",
    "t7": "Khám phá và bắt đầu hành trình mã hóa của chúng"
  },
  "newReg":{
    "dl": ['e-mail','Di động'],
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;",
    "yxgz": "Vui lòng nhập email hợp lệ",
    "dhgz": "Số điện thoại di động không chính xác"
  },
  "indexNew2": {
    "t1": "Giao dịch theo lệnh của chúng tôi",
    "t2": "Sử dụng Bitbank",
    "t3": "Bitbank là một sàn giao dịch trao đổi bitcoin và tài sản mã hóa được thiết kế khéo léo. Nó rất đơn giản, thuận tiện, an toàn và mạnh mẽ. Nó hỗ trợ giao dịch trên nhiều nền tảng web và điện thoại thông minh. Dữ liệu và biểu đồ giao dịch được cập nhật theo thời gian thực. Toàn diện phân tích giá thị trường cung cấp hơn 60 công cụ phân tích kỹ thuật. Hãy bắt đầu giao dịch ",
    "ksjy": "Bắt đầu giao dịch",
    "ly": "5 lý do để chọn Bitbank",
    "item1_t1": "Khối lượng giao dịch hàng đầu",
    "item1_t2": "Khối lượng giao dịch tài sản tiền điện tử số 1 *",
    "item1_t3": "Tính thanh khoản cao, giao dịch thoải mái (trải nghiệm giao dịch dễ chịu). Liệt kê 12 loại tài sản tiền điện tử.",
    "item2_t1": "Đánh giá cao của bên thứ ba",
    "item2_t2": "Môi trường giao dịch an toàn",
    "item2_t3": "Sử dụng ví lạnh ngoại tuyến. Sử dụng Multisig để ngăn chặn tin tặc. Bảo vệ tài sản của bạn bằng công nghệ cao",
    "item3_t1": "Ứng dụng dễ sử dụng và đáng tin cậy",
    "item3_t2": "Ứng dụng dễ sử dụng và đơn giản",
    "item3_t3": "Một ứng dụng đáng tin cậy với các chức năng phong phú. Nó có thể duy trì các cơ hội giao dịch bên ngoài giao dịch.",
    "item4_t1": "Mở cửa cả ngày",
    "item4_t2": "Có thể gửi vàng",
    "item4_t3": "Hỗ trợ tiền gửi 24 giờ, kể cả ngày lễ!",
    "item5_t1": "Điện thoại thông minh và PC",
    "item5_t2": "Thiết kế nhân bản",
    "item5_t3": "Ngay cả khi bạn sử dụng điện thoại thông minh, bạn có thể thực hiện các giao dịch đơn giản và đủ điều kiện mà không do dự",
    "aqkk": "An toàn và đáng tin cậy",
    "aqkk2": "Giao dịch Bitcoin Bitbank",
    "cjzh": "Tạo tài khoản",
  },
  "xbsg":{
    "title": "Tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "ghi lại",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy (usdt)",
    "dhkbs" :"Trong khi chờ thanh toán",
    "jkje": "số tiền (usdt)",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "đăng ký chuỗi cho vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "bind":{
    "title": "email",
    "ybd": "Ràng buộc",
    "wbd": "Không ràng buộc",
    "ts": "Để bảo vệ tài khoản của bạn, bạn nên liên kết một địa chỉ email",
    "qsryxdz": "địa chỉ email"
  },
  "tipsNew": {
    "yjj": "từ chối",
    "shz": "chuộc lỗi"
  },
  "newIndex2": {
    "zxhy": "Báo giá mới nhất",
    "jypt": "Nền tảng giao dịch",
    "dqwz": "Vị trí hiện tại",
    "yzm": "Mã xác minh",
    "qrmm": "Xác nhận mật khẩu",
    "djdl": "Nhấp để đăng nhập",
    "ghdjy": "Thỏa thuận tốt hơn",
    "ghdsh": "Cuộc sống tốt đẹp hơn",
    "about": "Trung tâm trao đổi tiền điện tử sáng tạo nhất thế giới nằm ở đây, nơi bạn có thể mua, giao dịch và kiếm tiền điện tử với hàng trăm loại tiền điện tử trong tầm tay của bạn.",
    "index01": "Cổng vào Bitcoin và hơn thế nữa",
    "index02": "Nền tảng dịch vụ tài sản kỹ thuật số hàng đầu thế giới",
    "index03": "Tất cả các giao dịch đều miễn phí",
    "index04": "Phí mở tài khoản, phí duy trì tài khoản, phí dừng lỗ, phí đặt cọc, phí lưu trữ / giao hàng đều miễn phí.",
    "index05": "An toàn và bảo mật",
    "index06": "Sử dụng kiến ​​thức chuyên môn mà GMI INT đã tích lũy kể từ khi thành lập, chúng tôi đang xây dựng các hệ thống mạnh mẽ và triển khai các biện pháp bảo mật khác nhau để bảo vệ tài sản của khách hàng một cách an toàn và bảo mật.",
    "index07": "Cả giao dịch vật chất và giao dịch đòn bẩy đều khả dụng",
    "index08": "Các giao dịch nhỏ có thể được thực hiện từ khoảng $ 10, mức chênh lệch thấp nhất trong ngành và số dư tài khoản có thể được sử dụng làm tài sản đảm bảo cho các giao dịch có đòn bẩy. Chỉ GMI INT mới có thể tính phí đòn bẩy.",
    "index09": "Mã thông báo được thiết kế để trao quyền cho cộng đồng GMI INT",
    "index10": "Unus Sed LEO là một mã thông báo ứng dụng được thiết kế để giúp những người dùng tìm cách tối đa hóa lợi ích và chức năng của nền tảng giao dịch GMI INT đáp ứng nhu cầu của họ.",
    "index11": "Mã thông báo được thiết kế để trao quyền cho cộng đồng GMI INT",
    "index12": "Mở ra một cuộc sống tốt đẹp hơn",
    "index13": "Mọi người đều có thể sở hữu tiền điện tử. Mọi người đều có thể giao dịch phần mềm tiền điện tử. Đây là cách Bitget có thể đưa bạn tiến thêm một bước.",
    "index14": "Sản phẩm đổi mới",
    "index15": "Giao dịch sao chép một cú nhấp chuột",
    "index16": "Không chuyển đổi mã thông báo khi giao dịch",
    "index17": "Các sàn giao dịch phái sinh chính hỗ trợ ký quỹ USDC",
    "index18": "Kiểm soát rủi ro thông qua cách ly ví nóng và ví lạnh",
    "index19": "12 xếp hạng a + từ SSL Labs",
    "index20": "Bảo mật đáng tin cậy được hỗ trợ bởi Suntwin Technology, Green Pine Cloud Security, HEAP và Armors",
    "index21": "Dịch vụ khách hàng xuất sắc",
    "index22": "Hỗ trợ trực tuyến 24/7 bằng nhiều ngôn ngữ",
    "index23": "Hỗ trợ 1-1 cho khách hàng VIP",
    "index24": "Trung tâm Phần thưởng Cộng đồng",
    "index25": "Được xây dựng bởi thương nhân dành cho thương nhân",
    "index26": "Giao dịch các tài sản kỹ thuật số khác nhau như Bitcoin, Ethereum, Solana và dogcoin với chi phí giao dịch thấp",
    "index27": "Các công cụ và thông tin bạn cần để mua, bán, giao dịch, đầu tư và sử dụng tiền điện tử",
    "index28": "Bảo mật hàng đầu trong ngành",
  },
  "langNew":{
    "szhb": "tiền điện tử",
    "gjs": "Kim loại",
    "yy": "thô",
    "jy": "Buôn bán",
    "jmhb": "tiền điện tử",
    "yxhy": "Hợp đồng vĩnh viễn",
    "gdjy": "danh sách hàng chờ",
    "khh": "Tài khoản đang mở",
    "qsrkhh": "Vui lòng nhập ngân hàng",
    "yhkh": "Tài khoản ngân hàng",
    "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
    "mnzh":"tài khoản demo",
    "cjmnzhcg":"Tài khoản demo được tạo thành công",
    "tcmnzh":"Thoát khỏi tài khoản demo",
   }
}



// WEBPACK FOOTER //
// ./src/lang/vn.js